import {
  MultiValueCookie,
  SingleValueCookie,
  cookieExists,
} from 'saddlebag-cookie';

type MultiValueCookieInstance = InstanceType<typeof MultiValueCookie>;
type SingleValueCookieInstance = InstanceType<typeof SingleValueCookie>;

const getMultiValueCookie = (name: string) => new MultiValueCookie(name);

const getSingleValueCookie = (name: string): SingleValueCookieInstance =>
  new SingleValueCookie(name);

export {
  MultiValueCookieInstance,
  SingleValueCookieInstance,
  getMultiValueCookie,
  getSingleValueCookie,
  cookieExists,
};
